import { type CalendarResourceType } from '../../ResourceCalendar';

const calenderResourceGroupLabels: Record<Uppercase<CalendarResourceType>, string> = {
  EXPERTE: 'Trainer',
  SEMINARRAUM: 'Seminarräume',
  GRUPPENRAUM: 'Gruppenräume',
  STANDORT: 'Standorte',
} as const;

export const content = {
  calenderResourceGroupLabels,

  warnungen: {
    planungInaktiv: 'Die Planungsinformationen für dieses Thema sind inaktiv (Workflow-Status 190).',
    selectionOutsideView:
      'Achtung, der Ablauf erstreckt sich über den sichtbaren Zeitraum hinaus. Bitte passe den sichtbaren Bereich über die Kalenderauswahl an.',
  },
  fehler: {
    missingAblaufTemplate: 'Kein Ablauf in CServ gepflegt.',
  },
} as const;
